'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002e$002dProduct15 from "./scala.-Product15.js";
var $p;
/** @constructor */
function $c_T15(_1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15) {
  this.nm = null;
  this.nt = null;
  this.nu = null;
  this.nv = null;
  this.nw = null;
  this.nx = null;
  this.ny = null;
  this.nz = null;
  this.nA = null;
  this.nn = null;
  this.no = null;
  this.np = null;
  this.nq = null;
  this.nr = null;
  this.ns = null;
  this.nm = _1;
  this.nt = _2;
  this.nu = _3;
  this.nv = _4;
  this.nw = _5;
  this.nx = _6;
  this.ny = _7;
  this.nz = _8;
  this.nA = _9;
  this.nn = _10;
  this.no = _11;
  this.np = _12;
  this.nq = _13;
  this.nr = _14;
  this.ns = _15;
}
export { $c_T15 as $c_T15 };
$p = $c_T15.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_T15;
/** @constructor */
function $h_T15() {
}
export { $h_T15 as $h_T15 };
$h_T15.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.n = (function() {
  return 15;
});
$p.g = (function(n) {
  return $j_scala$002e$002dProduct15.$f_s_Product15__productElement__I__O(this, n);
});
$p.m = (function() {
  return $j_java$002elang$002e$002dObject.$m_s_util_hashing_MurmurHash3$().av(this, 1834180931, true);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_T15) && (((((((((((((($j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.nm, x$0.nm) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.nt, x$0.nt)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.nu, x$0.nu)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.nv, x$0.nv)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.nw, x$0.nw)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.nx, x$0.nx)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.ny, x$0.ny)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.nz, x$0.nz)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.nA, x$0.nA)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.nn, x$0.nn)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.no, x$0.no)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.np, x$0.np)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.nq, x$0.nq)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.nr, x$0.nr)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.ns, x$0.ns))));
});
$p.o = (function() {
  return "Tuple15";
});
$p.b = (function() {
  return (((((((((((((((((((((((((((((("(" + this.nm) + ",") + this.nt) + ",") + this.nu) + ",") + this.nv) + ",") + this.nw) + ",") + this.nx) + ",") + this.ny) + ",") + this.nz) + ",") + this.nA) + ",") + this.nn) + ",") + this.no) + ",") + this.np) + ",") + this.nq) + ",") + this.nr) + ",") + this.ns) + ")");
});
function $isArrayOf_T15(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eE)));
}
export { $isArrayOf_T15 as $isArrayOf_T15 };
var $d_T15 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_T15, "scala.Tuple15", ({
  eE: 1,
  b: 1,
  c: 1,
  rN: 1,
  a: 1
}));
export { $d_T15 as $d_T15 };
